const pageNameKey = "alarmList";

export const alarmListEn = {
  [pageNameKey]: {
    undefinedChannelsObjectError:
      "Error fetching timeseries channels for alarm list. Please try again later.",
    transferAlarmProfilesToClientButton: "Save Condition Monitoring Settings",
    transferAlarmProfilesToClientButtonTooltip:
      "You might not have the required permissions to save the Condition Monitoring settings.",
    couldNotFindAnyNodesWithThatName:
      "Could not find any nodes with that name.",
    noNodesFound: "No nodes available for this machine.",
    searchForNodes: "Search by Node Name or Node Id",
  },
};

export const alarmListPtBr = {
  [pageNameKey]: {
    undefinedChannelsObjectError:
      "Erro ao buscar canais de séries temporais para a lista de alarmes. Tente novamente mais tarde.",
    transferAlarmProfilesToClientButton:
      "Salvar configurações de monitoramento de condições",
    transferAlarmProfilesToClientButtonTooltip:
      "Talvez você não tenha as permissões necessárias para salvar as configurações de Monitoramento de Condição.",
    couldNotFindAnyNodesWithThatName:
      "Não foi possível encontrar nenhum nó com esse nome.",
    noNodesFound: "Não há nós disponíveis para esta máquina.",
    searchForNodes: "Pesquisar por nome ou ID do nó",
  },
};

export const alarmListDe = {
  [pageNameKey]: {
    undefinedChannelsObjectError:
      "Fehler beim Abrufen der Timeseries-Kanäle für die Alarm-Liste. Bitte versuchen Sie es später erneut.",
    transferAlarmProfilesToClientButton:
      "Condition-Monitoring Einstellungen speichern",
    transferAlarmProfilesToClientButtonTooltip:
      "Möglicherweise verfügen Sie nicht über die erforderlichen Berechtigungen, um die Condition-Monitoring-Einstellungen zu speichern.",
    couldNotFindAnyNodesWithThatName:
      "Es konnten keine Knoten mit diesem Namen gefunden werden.",
    noNodesFound: "Für diese Maschine sind keine Knoten verfügbar.",
    searchForNodes: "Nach Knotenname oder Knoten-ID suchen",
  },
};

export const alarmListZhHans = {
  [pageNameKey]: {
    undefinedChannelsObjectError:
      "获取告警列表的时间序列通道时出错。请稍后再试。",
    transferAlarmProfilesToClientButton: "保存条件监控设置",
    transferAlarmProfilesToClientButtonTooltip:
      "您可能没有保存条件监控设置所需的权限。",
    couldNotFindAnyNodesWithThatName: "未找到具有该名称的节点。",
    noNodesFound: "此机器没有可用节点。",
    searchForNodes: "按节点名称或节点 ID 搜索",
  },
};

export const alarmListIt = {
  [pageNameKey]: {
    undefinedChannelsObjectError:
      "Errore durante il recupero dei dati necessari per la creazione dell'elenco degli allarmi. Per favore riprova più tardi.",
    transferAlarmProfilesToClientButton:
      "Salva le impostazioni di monitoraggio delle condizioni",
    transferAlarmProfilesToClientButtonTooltip:
      "Potresti non disporre delle autorizzazioni necessarie per salvare le impostazioni di monitoraggio delle condizioni.",
    couldNotFindAnyNodesWithThatName: "Impossibile trovare nodi con quel nome.",
    noNodesFound: "Nessun nodo disponibile per questa macchina.",
    searchForNodes: "Cerca per nome nodo o ID nodo",
  },
};

export const alarmListEs = {
  [pageNameKey]: {
    undefinedChannelsObjectError:
      "Error al obtener los canales de series temporales para la lista de alarmas. Vuelve a intentarlo más tarde.",
    transferAlarmProfilesToClientButton:
      "Guardar la configuración de monitorización de condición",
    transferAlarmProfilesToClientButtonTooltip:
      "Es posible que no tengas los permisos necesarios para guardar la configuración de supervisión de condiciones.",
    couldNotFindAnyNodesWithThatName:
      "No se pudieron encontrar nodos con ese nombre.",
    noNodesFound: "No hay nodos disponibles para esta máquina.",
    searchForNodes: "Buscar por nombre o ID del nodo",
  },
};

export const alarmListNl = {
  [pageNameKey]: {
    couldNotFindAnyNodesWithThatName:
      "Kon geen knooppunten vinden met die naam.",
    noNodesFound: "Geen knooppunten beschikbaar voor deze machine.",
    searchForNodes: "Zoeken op knooppuntnaam of knooppunt-ID",
    transferAlarmProfilesToClientButton:
      "Conditiebewakingsinstellingen opslaan",
    transferAlarmProfilesToClientButtonTooltip:
      "Mogelijk beschikt u niet over de vereiste rechten om de conditiebewakingsinstellingen op te slaan.",
    undefinedChannelsObjectError:
      "Fout bij het ophalen van de timeseries-kanalen voor de alarmlijst. Probeer het later opnieuw.",
  },
};

export const alarmListTr = {
  [pageNameKey]: {
    couldNotFindAnyNodesWithThatName: "Bu adda herhangi bir düğüm bulunamadı.",
    noNodesFound: "Bu makine için kullanılabilir düğüm yok.",
    searchForNodes: "Düğüm Adına veya Düğüm Kimliğine göre arayın",
    transferAlarmProfilesToClientButton: "Durum İzleme Ayarlarını Kaydet",
    transferAlarmProfilesToClientButtonTooltip:
      "Durum İzleme ayarlarını kaydetmek için gerekli izinlere sahip olmayabilirsiniz.",
    undefinedChannelsObjectError:
      "Alarm listesi için zaman serisi kanalları alınırken hata oluştu. Lütfen daha sonra tekrar deneyin.",
  },
};
